var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('div',{staticClass:"footer-main",class:_vm.routeBgClass},[_c('span',[_vm._v("备案号：")]),_c('a',{attrs:{"href":"http://beian.miit.gov.cn","target":"_blank"}},[_vm._v("渝ICP备2024021358号-4")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }